import { PdfTemplateModelType, PdfTemplatePdfTypesTy } from '@teinor/erp/types/company/config/pdfTemplate'

export interface PdfTemplatesAction {
    type: 'CHANGE_PDFTEMPLATE'
    payload: PdfTemplateModelType[]
}

export type ReduxPdfTemplateTypes = keyof PdfTemplatePdfTypesTy

export type PdfTemplateResult = Record<ReduxPdfTemplateTypes, DictionaryPdfTemplate>

export type DictionaryPdfTemplate = { [id: number]: PdfTemplateModelType }
export type PdfTemplatePayload = PdfTemplateResult | null

export default function pdfTemplates(state: PdfTemplatePayload = null, action: PdfTemplatesAction): PdfTemplatePayload {
    switch (action.type) {
        case 'CHANGE_PDFTEMPLATE':
            const result: PdfTemplateResult = { buyOrder: {}, buyDeliveryNote: {}, buyInvoice: {}, quoteOrder: {}, sellOrder: {}, sellDeliveryNote: {}, sellInvoice: {}, ticket: {}, sellRefundInvoice: {}, sellRefundDeliveryNote: {}, ticketPDF: {}, customerMaterialStockOrder: {}, ticketRefund: {}, ticketRefundPDF: {}, voucher: {}, voucherPDF: {}, giftTicket: {}, giftTicketPDF: {}, manufacturingPDF: {}, adjustmentDeliveryNote: {}, cashRegister: {}, reparation: {}, ticketReparation: {}, warehouseTransfer: {}, productCertificate: {} }
                for (const template of action.payload) {
                    const id = template.id
                    const type = template.type
                    result[type][id] = template
                }
            return state = result
        default:
            return state
    }
}